import styled from 'styled-components';

export const MapWrapper = styled.div`
  height: 370px;
  width: 100%;
  padding-top: 40px;
  position: relative;

  /* Ensure Google Maps renders properly */
  & > div {
    height: 100% !important;
    width: 100% !important;
  }
`;

export const PointOnMapWrap = styled.div`
  position: relative;
  width: 30px;
  height: 30px;
  transform: translate(-50%, -100%);
  transition: transform 0.3s ease-in-out;
`;

export const MarkerWrapper = styled.div`
  position: relative;
  transition: transform 0.3s ease-in-out;
  ${(props) => props.$lat && ''} /* Use transient prop */
  ${(props) => props.$lng && ''} /* Use transient prop */
`;
